import './Dropdown.scss'
import {useRef, useState} from 'react'
import {useOutsideClick} from '../../hooks/useOutsideClick'

export const Dropdown = ({children}) => {
    const [isOpen, setIsOpen] = useState(false)
    const ref = useRef()
    useOutsideClick(ref, () => setIsOpen(false))

    const toggleMenu = (e) => {
        e.stopPropagation()
        setIsOpen(!isOpen)
    }

    return (
       <div ref={ref} className="dropdown" data-state={isOpen ? 'open' : 'closed'} onClick={toggleMenu}>
           {children}
       </div>
    )
}

const Button = ({children}) => {
    return (
        <div className="dropdown-btn">
            {children}
        </div>
    )
}
Dropdown.Button = Button

const List = ({children}) => {
    return (
        <ul className="dropdown-list">
            {children}
        </ul>
    )
}
Dropdown.List = List

const ListItem = ({children}) => {

    return (
        <li className="dropdown-list-item">
            {children}
        </li>
    )
}
Dropdown.ListItem = ListItem
